/* ====================================================================
   FLOOREVER — COUPE DU SOL PAR FAMILLE, IMAGE SEULE
   (sections/floorever-coupe.liquid). Vanilla JS, defer, aucune dépendance.

   Décision Christopher 16/10/2026 : les couches diffèrent selon la
   famille (souple / rigide / collée) → un sélecteur de pastilles
   (role=tablist) bascule la scène de la famille choisie ; dans chaque
   scène, les REPÈRES-BOUTONS posés sur le visuel et les PUCES numérotées
   affichent la couche choisie dans le bloc fixe (aria-live). Rendu
   serveur : famille par défaut visible, couche 1 active ; les autres
   portent `hidden` (progressive enhancement : sans JS, famille par défaut
   et couche 1 lisibles).

   Ancres : `#coupe-souple` / `#coupe-rigide` / `#coupe-collee` (liens
   « Voir la coupe de cette lame » des cartes de la section gammes)
   sélectionnent la famille et font défiler jusqu'à la section.
   ==================================================================== */
(function () {
  'use strict';

  var FAMILLES = /^#coupe-(souple|rigide|collee)$/;

  function initCouches(variante) {
    var boutons = variante.querySelectorAll('button[data-coupe-couche]');
    var textes = variante.querySelectorAll('.coupe-couche[data-coupe-couche]');
    if (!boutons.length || !textes.length) return;

    function choisirCouche(n) {
      textes.forEach(function (t) {
        t.hidden = t.getAttribute('data-coupe-couche') !== n;
      });
      boutons.forEach(function (b) {
        var on = b.getAttribute('data-coupe-couche') === n;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    boutons.forEach(function (b) {
      b.addEventListener('click', function () {
        choisirCouche(b.getAttribute('data-coupe-couche'));
      });
      /* flèches gauche / droite : couche suivante / précédente, le focus
         reste dans le même groupe (repères du visuel ou puces) */
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var total = textes.length;
        var n = parseInt(b.getAttribute('data-coupe-couche'), 10) || 1;
        var suivant = e.key === 'ArrowRight' ? (n % total) + 1 : ((n + total - 2) % total) + 1;
        choisirCouche(String(suivant));
        var groupe = b.closest('.coupe-visuel, .coupe-puces');
        var cible = groupe && groupe.querySelector('button[data-coupe-couche="' + suivant + '"]');
        if (cible) cible.focus();
      });
    });
  }

  function initUn(sec) {
    if (sec.dataset.coupeInit === '1') return;
    sec.dataset.coupeInit = '1';

    var pills = sec.querySelectorAll('[data-coupe-famille]');
    var variantes = sec.querySelectorAll('[data-coupe-variante]');
    if (!pills.length || !variantes.length) return;

    variantes.forEach(initCouches);

    function choisir(fam, depuisAncre) {
      variantes.forEach(function (v) {
        v.hidden = v.getAttribute('data-coupe-variante') !== fam;
      });
      pills.forEach(function (p) {
        var on = p.getAttribute('data-coupe-famille') === fam;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-selected', on ? 'true' : 'false');
        p.tabIndex = on ? 0 : -1;
      });
      if (depuisAncre) {
        var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        sec.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'start' });
      }
    }

    pills.forEach(function (p, i) {
      p.addEventListener('click', function () {
        choisir(p.getAttribute('data-coupe-famille'), false);
      });
      /* flèches gauche / droite entre les pastilles (pattern tabs) */
      p.addEventListener('keydown', function (e) {
        var j;
        if (e.key === 'ArrowRight') j = (i + 1) % pills.length;
        else if (e.key === 'ArrowLeft') j = (i + pills.length - 1) % pills.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = pills.length - 1;
        else return;
        e.preventDefault();
        pills[j].focus();
        choisir(pills[j].getAttribute('data-coupe-famille'), false);
      });
      /* Précharge le visuel d'une famille dès le survol ou le focus de sa
         pastille (sinon le cadre reste vide le temps du chargement). */
      function precharger() {
        var img = sec.querySelector('[data-coupe-variante="' + p.getAttribute('data-coupe-famille') + '"] img');
        if (img) img.loading = 'eager';
      }
      p.addEventListener('pointerenter', precharger);
      p.addEventListener('focus', precharger);
    });

    function depuisHash() {
      var m = FAMILLES.exec(window.location.hash);
      if (m) choisir(m[1], true);
    }
    window.addEventListener('hashchange', depuisHash);
    depuisHash();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-coupe]').forEach(initUn);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Rechargement de section dans l'éditeur de thème. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
}());
